import { Injectable } from '@angular/core';

@Injectable()
export class DataBlobService {
  createObjectURL(data: string) {
    const blob = new Blob([data], { type: 'text/csv' });
    return URL.createObjectURL(blob);
  }
}
